module.exports = __webpack_public_path__ + "img/home03.02faa4a6.png";